import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

interface GxSecondaryButtonProps {
  handleClose: () => void;
  onResendClick?: () => void;
  label?: string;
}
const GxSecondaryButton: React.FC<GxSecondaryButtonProps> = ({
  handleClose,
  label = "",
}) => {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      onClick={handleClose}
      className="gx-dialog-back-button gx-h4-eb"
    >
      <span className="gx-h4-b">{t(label)}</span>
    </Button>
  );
};

export default GxSecondaryButton;
